<template>
  <v-container fill-height fluid>
    <v-layout justify-center align-center>
      <v-flex column lg8 align-self-center>
        <material-card
          icon="mdi-format-list-checkbox"
          color="indigo"
          :title="$t('Pages.UserCheckoutForms.update')"
          :text="$t('Common.enter_details')">
          <v-card-text>
            <user-checkout-form edit @save="update" :userCheckoutForm="userCheckoutForm"></user-checkout-form>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import UserCheckoutForm from './Form'
  
  export default {
    components: {UserCheckoutForm},
    data: () => ({
      userCheckoutForm: {},
    }),
    computed: {

    },
    created () {
      this.getUserCheckoutForm();
    },
    methods: {
      getUserCheckoutForm(fetching = true){
        this.setFetching(fetching);
        this.repositories.userCheckoutForm.get(this.$route.params.id, 'warehouseTransactions,warehouse.warehouseStates,product.productSizes,user.workplaces').then(response => {
          this.userCheckoutForm = response.data.data;
          this.userCheckoutForm.user_id = this.userCheckoutForm.users && this.userCheckoutForm.users.length > 0 ? this.userCheckoutForm.users[0].id : null;
          this.userCheckoutForm.workplace_id = this.userCheckoutForm.workplace ? this.userCheckoutForm.workplace.id : null;
          this.userCheckoutForm.warehouse_id = this.userCheckoutForm.warehouse ? this.userCheckoutForm.warehouse.id : null;
          this.userCheckoutForm.product_size_id = this.userCheckoutForm.productSize ? this.userCheckoutForm.productSize.id : null;
          this.userCheckoutForm.quantity = this.userCheckoutForm.warehouseTransactions && this.userCheckoutForm.warehouseTransactions.length > 0 ? -1 * this.userCheckoutForm.warehouseTransactions[0].quantity : 1;
        }).finally(() => {
          this.setFetching(false);
        });
      },
      update(data){
        this.repositories.userCheckoutForm.update(this.userCheckoutForm.id, data).then((response) => {
          this.$toast.info(response.data.message);
          this.$router.push('/user-checkout-forms');
        });
      },
    }
  }
</script>

<style lang="scss">

</style>
